import { 
  GET_Customer, 
  SET_Customer_DATA, 
  RESET_Customer_DATA,
  SET_CITY_DATA,
  SET_AREAS_BY_CITY,
  SET_STATES_DATA
} from "types/actions/customerMaster.action";

import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";
import { CityModel } from "types/models/CityModel";
import { AreaModel } from "types/models/AreaModel";
import { AppActions } from "types";
import { StateModel } from "types/models/StatesModel";


export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentCustomer: CustomerMasterData | null;
  customer: CustomerMasterData[];
  customerCount: number;
  cities: CityModel[];
  areas: AreaModel[];
   states: StateModel[]; 
} = {
  currentCustomer: null,
  customer: [],
  customerCount: 0,
  cities: [],
  areas: [],
   states: [],
};

const CustomerMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case GET_Customer:
      return {
        ...state,
        customer: action.payload.customer,
        customerCount: action.payload.count,
      };

    case SET_Customer_DATA:
      return {
        ...state,
        currentCustomer: action.payload,
      };

    case RESET_Customer_DATA:
      return { ...state, currentCustomer: null };

    case SET_CITY_DATA:
      return {
        ...state,
        cities: action.payload, 
      };

case SET_AREAS_BY_CITY:
  return {
    ...state,
    areas: action.payload.rows,
  };
 case SET_STATES_DATA:
      return {
        ...state,
        states: Array.isArray(action.payload) ? action.payload : [],
      };
    default:
      return state;
  }
};

export default CustomerMaster;
